import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { DatosFacturacionService } from '../../shared/datos-facturacion.service';
import { datosFacturacion } from '../../entities/datosFacturacion';

@Component({
  selector: 'app-datos-facturacion',
  templateUrl: './datos-facturacion.component.html',
  styleUrls: ['./datos-facturacion.component.scss']
})
export class DatosFacturacionComponent {
  public listaDatosFacturacion: datosFacturacion[];

  constructor(
    private route: Router,
    private toastService: ToastrService,
    private datosFactService: DatosFacturacionService) { }
  
ngOnInit() {
this.obtenerListaDatos()
}

obtenerListaDatos() {
  this.datosFactService.obtenerListaDatos().subscribe((result: datosFacturacion[]) => {
    if(result.length > 0) {
      this.listaDatosFacturacion = result;
      // console.log(result);
    } else {
      this.listaDatosFacturacion = [];

    }
  })
}

  agregarDatos() {
    this.route.navigateByUrl('/pages/agregar-datos-facturacion')
  }

  editarData(id: number) {
    this.route.navigateByUrl('/pages/editar-datos-facturacion/' + id)

  }

  eliminarData(id: number) {
    Swal.fire({
      title: 'Eliminar',
      text: '¿Está seguro de eliminar los datos de facturación?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.value) {
        this.datosFactService.eliminarDatos(id).subscribe(res => {
          this.obtenerListaDatos();
          Swal.fire(
            'Eliminado!',
            'Los datos han sido eliminados correctamente!',
            'success'
          );
        }, err => {
          Swal.fire(
            'Error en la operación',
            'Error al intentar eliminar los datos',
            'error'
          );
        });
      }
    })

  }
}
